module.exports = __webpack_public_path__ + "img/TA_CMYK.ea88dedd.png";